import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const usePrintReport = id => {
  const [report, setReport] = useState(null);
  const [images, setImages] = useState({});
  const [failures, setFailures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const urls = [];
    setLoading(true); setError(""); setReport(null); setImages({}); setFailures([]);
    (async () => {
      try {
        const {data} = await axios.get(`${API}/incidents/${id}`, {signal:controller.signal});
        if (!active) return;
        setReport(data);
        const paths = [...new Set((data.display_fields || []).filter(f => f.field_type === "image" && Array.isArray(f.value)).flatMap(f => f.value))];
        const assets = await Promise.all(paths.map(async path => {
          try {
            const response = await axios.get(`${API}/files/${path}`, {responseType:"blob", signal:controller.signal, timeout:20000});
            if (!active) return [path,null];
            const url = URL.createObjectURL(response.data); urls.push(url);
            const img = new Image(); img.src = url; await img.decode();
            return [path,url];
          } catch { return [path,null]; }
        }));
        if (active) { setImages(Object.fromEntries(assets)); setFailures(assets.filter(([,url]) => !url).map(([path]) => path)); }
      } catch (e) {
        if (active) setError(e.response?.status === 403 ? "Kein Zugriff auf diese Meldung." : "Die Meldung konnte nicht für den Druck geladen werden.");
      } finally { if (active) setLoading(false); }
    })();
    return () => { active = false; controller.abort(); urls.forEach(url => URL.revokeObjectURL(url)); };
  }, [id]);
  return { report, images, failures, loading, error };
};